import React, { useState, forwardRef, useImperativeHandle } from 'react';
import UserService from '../../../class/User/UserService';

const ModalForgot = forwardRef((props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Expose open and close methods to parent component
  useImperativeHandle(ref, () => ({
    open: () => setIsOpen(true),
    close: () => {
        setIsOpen(false);   // Close the modal
      }
  }));

  const handleCloseModal = () => {
    props.setBlock('block');
    setIsOpen(false);
  };
  

  // Handle form submission to send reset email
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setErrorMessage(''); // Clear any previous error messages
    setSuccessMessage(''); // Clear previous success messages

    try {
      const response = await UserService.sendReset(email); // Call the service to send reset email

      if (response.status) {
        // On success, hide the form and display the success message
        setSuccessMessage('Vi è stata inviata l\'istruzione per il recupero della password al tuo indirizzo email.');
      } else {
        // If there was an error, display the error message
        setErrorMessage('Si è verificato un errore. Per favore, riprova.');
      }
    } catch (error) {
      setErrorMessage('Si è verificato un errore. Per favore, riprova.');
      console.error(error);
    }
  };

  return (
    <div className={`modal fade registration_modal ${isOpen ? 'show' : ''}`} id="forgot_modal" tabIndex="-1" role="dialog" style={{ display: isOpen ? 'block' : 'none', zIndex: 10000000000000 }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h3>Recupera password</h3>
            <button className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>


            
          </div>
          <div className="modal-body"> 
            {/* Show success message if email sent */}
            {successMessage ? (
                <>
              <div className="alert alert-success" role="alert"> 
                <p>{successMessage}</p>
               
            
              </div>
               <div className="field button-field">
               <button type="submit" onClick={handleCloseModal}>Close</button>

 
             </div>
             </>
            ) : ( 
              <section className="forms">
                <div className="form signup">
                  <div className="form-content">
                    {/* Show form if no success message */}
                    <form onSubmit={handleForgotPassword}>
                      <label>Inserisci la tua email per recuperare la password:</label>
                      <div className="field input-field">
                        <input
                          type="email"
                          placeholder="Email"
                          className="input"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                      <div className="field button-field">
                        <button type="submit">Forgot</button>
                      </div>
                    </form>
                    {/* Show error message if there's an error */}
                    {errorMessage && <div className="alert alert-danger mt-4">{errorMessage}</div>}
                  </div>
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModalForgot;
